import React, { useEffect, useState } from 'react';
import { A11y, EffectFade, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EqualHeight, EqualHeightElement } from 'react-equal-height/clean';

import { PaginationOptions } from 'swiper/types';

import { Image } from '../../Image/Image';

import { CarouselProps } from '../Carousel.types';

import { RichText } from '../../RichText/RichText';

import CarouselSlideWithImage from './CarouselSlideWithImage';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

import * as classes from './CarouselWithImage.module.scss';

const CarouselWithImage: React.FC<CarouselProps> = ({ elements, title }) => {
    const [fontLoaded, setFontLoaded] = useState<boolean>(false);

    const pagination: PaginationOptions = {
        clickable: true,
        bulletClass: classes.customBullet,
        bulletActiveClass: classes.customBulletActive,
        horizontalClass: classes.customBulletContainer,
    };

    useEffect(() => {
        document.fonts?.ready.then(() => {
            setFontLoaded(!fontLoaded);
        });
    }, []);

    return (
        <>
            {title && (
                <div className={classes.titleContainer}>
                    <RichText content={title} textSize="heading3" />
                </div>
            )}
            <EqualHeight updateOnChange={fontLoaded}>
                <Swiper
                    autoHeight={false}
                    className="customSwiper"
                    pagination={pagination}
                    modules={[Pagination, A11y, EffectFade]}
                    effect="fade"
                >
                    {elements.map((element, index) => {
                        if (element.content.__typename === 'ContentfulSetOfTextWithHeaderTextWithHeader') {
                            return (
                                <SwiperSlide key={index} className={classes.customSwiperSlide}>
                                    <EqualHeightElement name="equalColumnSlide">
                                        <CarouselSlideWithImage
                                            title={element.content.richTitle}
                                            singleColumnContent={element.content.singleColumnContent}
                                            icons={element.content.icons}
                                            backgroundImage={element.image}
                                            multiColumnContent={element.content.multiColumnContent}
                                            image={element.image}
                                        />
                                    </EqualHeightElement>
                                    <div className={classes.wrapper}>
                                        <Image image={element.image} classWrapper={classes.imgWrapper} />
                                    </div>
                                </SwiperSlide>
                            );
                        }
                    })}
                </Swiper>
            </EqualHeight>
        </>
    );
};

export default CarouselWithImage;
